var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: flex-start;\n  margin: 2px 0;\n'], ['\n  display: flex;\n  justify-content: flex-start;\n  margin: 2px 0;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import { Row, Col } from 'reactstrap';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Checkbox from './Checkbox';

var Content = styled.div(_templateObject);

var CheckBoxCols = function CheckBoxCols(_ref) {
  var checkedTypes = _ref.checkedTypes,
      _onChange = _ref.onChange,
      options = _ref.options;
  return React.createElement(
    Row,
    null,
    options.map(function (item, idx) {
      var checked = checkedTypes.some(function (type) {
        return type.id && type.id === item.id;
      });
      return React.createElement(
        Col,
        { lg: '6', md: '6', sm: '6', xs: '12', key: item.id },
        React.createElement(
          Content,
          null,
          React.createElement(
            'label',
            { onChange: function onChange() {
                return _onChange(item);
              } },
            React.createElement(Checkbox, { checked: checked }),
            item.title
          )
        )
      );
    })
  );
};

CheckBoxCols.displayName = 'CheckBoxCols';
CheckBoxCols.propTypes = process.env.NODE_ENV !== "production" ? {
  checkedTypes: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.string
  })),
  options: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.string
  })),
  onChange: PropTypes.func
} : {};

export default CheckBoxCols;